const DEFAULT_SOLFACIL_CDN = 'https://cdn.solfacil.com.br'

export function useCdn(providerName = 'solfacil'): string {
  if (typeof window === 'undefined')
    return `${DEFAULT_SOLFACIL_CDN}/`

  const provider = window.__CDN_PROVIDERS__?.find(({ name }) => name === providerName)
  const base = provider?.url ?? DEFAULT_SOLFACIL_CDN
  return base.endsWith('/') ? base : `${base}/`
}
